const xrdJcamp1 = `
##TITLE=
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=X-RAY DIFFRACTION
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=2Theta
##YUNITS=Intensity
##XFACTOR=1.0
##YFACTOR=1.0
##FIRSTX=93.0001
##LASTX=97.996592
##MAXX=97.996592
##MAXY=1106.38
##MINX=93.0001
##MINY=10.3125
##NPOINTS=327
##XYDATA= (XY..XY)
93.0001, 10.3125
93.015427, 10.67708
93.030753, 11.53646
93.04608, 11.30208
93.061407, 11.74479
93.076733, 11.17188
93.09206, 12.21354
93.107387, 11.51042
93.122713, 12.60417
93.13804, 11.97917
93.153367, 12.16146
93.168693, 11.51042
93.18402, 11.14583
93.199347, 11.61458
93.214673, 10.85938
93.23, 10.80729
93.245327, 11.45833
93.260653, 11.77083
93.27598, 10.80729
93.291307, 11.09375
93.306633, 11.69271
93.32196, 12.10937
93.337287, 12.5
93.352613, 13.04687
93.36794, 12.47396
93.383267, 11.69271
93.398593, 11.30208
93.41392, 11.95313
93.429247, 11.01563
93.444573, 11.74479
93.4599, 12.5
93.475227, 11.74479
93.490553, 11.58854
93.50588, 11.04167
93.521207, 12.73437
93.536533, 12.31771
93.55186, 12.00521
93.567187, 12.13542
93.582513, 12.13542
93.59784, 12.96875
93.613167, 12.36979
93.628493, 13.33333
93.64382, 12.34375
93.659147, 13.35937
93.674473, 12.65625
93.6898, 12.8125
93.705127, 13.09896
93.720453, 13.15104
93.73578, 13.04687
93.751107, 13.125
93.766433, 13.72396
93.78176, 13.51562
93.797087, 12.44792
93.812413, 12.57812
93.82774, 13.09896
93.843067, 13.28125
93.858393, 13.38542
93.87372, 14.55729
93.889047, 12.68229
93.904373, 13.67187
93.9197, 13.72396
93.935026, 14.50521
93.950353, 14.81771
93.96568, 14.97396
93.981006, 14.19271
93.996333, 13.54167
94.01166, 14.84375
94.026986, 14.21875
94.042313, 15.75521
94.05764, 14.71354
94.072966, 14.79167
94.088293, 15.07812
94.10362, 14.79167
94.118946, 16.58854
94.134273, 15.3125
94.1496, 15.54687
94.164926, 15.0
94.180253, 15.52083
94.19558, 16.40625
94.210906, 17.00521
94.226233, 18.98438
94.24156, 20.625
94.256886, 22.08333
94.272213, 23.46354
94.28754, 19.50521
94.302866, 18.82813
94.318193, 17.05729
94.33352, 18.46354
94.348846, 20.26042
94.364173, 19.42708
94.3795, 17.96875
94.394826, 19.76563
94.410153, 20.46875
94.42548, 21.32813
94.440806, 19.84375
94.456133, 21.35417
94.47146, 20.625
94.486786, 22.76042
94.502113, 22.65625
94.51744, 24.375
94.532766, 25.49479
94.548093, 27.5
94.56342, 27.78646
94.578746, 30.26042
94.594073, 29.76562
94.6094, 31.74479
94.624726, 31.04167
94.640053, 32.96875
94.65538, 34.66146
94.670706, 33.64583
94.686033, 33.90625
94.70136, 34.40104
94.716686, 35.33854
94.732013, 35.625
94.74734, 36.43229
94.762666, 39.29688
94.777993, 39.19271
94.79332, 39.89583
94.808646, 41.69271
94.823973, 43.30729
94.8393, 48.93229
94.854626, 50.10416
94.869953, 51.58854
94.88528, 57.65625
94.900606, 61.71875
94.915933, 71.84895
94.93126, 77.3177
94.946586, 84.42708
94.961913, 91.92708
94.97724, 106.1719
94.992566, 124.375
95.007893, 144.5573
95.02322, 175.7813
95.038546, 206.25
95.053873, 255.9375
95.0692, 326.6667
95.084526, 414.6614
95.099853, 551.1198
95.11518, 693.5156
95.130506, 859.401
95.145833, 992.2135
95.16116, 1073.229
95.176486, 1106.38
95.191813, 1079.688
95.20714, 1042.37
95.222466, 935.4687
95.237793, 824.6354
95.25312, 699.6614
95.268446, 582.1094
95.283773, 475.026
95.2991, 402.0052
95.314426, 341.875
95.329753, 306.7969
95.34508, 288.9323
95.360406, 281.6146
95.375733, 291.9792
95.39106, 310.1042
95.406386, 357.1354
95.421713, 419.0364
95.43704, 484.0625
95.452366, 548.776
95.467693, 593.5938
95.48302, 622.8906
95.498346, 612.7604
95.513673, 590.7813
95.529, 544.7656
95.544326, 489.6875
95.559653, 417.4739
95.57498, 347.3177
95.590306, 283.6979
95.605633, 230.651
95.62096, 191.6406
95.636286, 163.3594
95.651613, 140.3125
95.66694, 119.0104
95.682266, 104.9479
95.697593, 94.375
95.71292, 84.34895
95.728246, 73.125
95.743573, 66.3802
95.7589, 61.48437
95.774226, 55.98958
95.789553, 51.01562
95.804879, 47.16146
95.820206, 44.47916
95.835533, 39.58333
95.850859, 40.33854
95.866186, 37.34375
95.881513, 35.57291
95.896839, 32.78646
95.912166, 33.15104
95.927493, 29.27083
95.942819, 29.01042
95.958146, 29.03646
95.973473, 27.47396
95.988799, 27.08333
96.004126, 26.11979
96.019453, 24.21875
96.034779, 24.86979
96.050106, 21.48438
96.065433, 23.09896
96.080759, 21.97917
96.096086, 22.29167
96.111413, 22.55208
96.126739, 22.39583
96.142066, 21.06771
96.157393, 21.77083
96.172719, 20.3125
96.188046, 19.375
96.203373, 20.70313
96.218699, 18.22917
96.234026, 17.99479
96.249353, 18.85417
96.264679, 18.77604
96.280006, 18.02083
96.295333, 18.17708
96.310659, 18.77604
96.325986, 17.39583
96.341313, 18.82813
96.356639, 17.36979
96.371966, 17.03125
96.387293, 16.45833
96.402619, 19.03646
96.417946, 16.84896
96.433273, 17.8125
96.448599, 17.34375
96.463926, 17.68229
96.479253, 17.23958
96.494579, 16.82292
96.509906, 17.29167
96.525233, 15.9375
96.540559, 17.03125
96.555886, 15.88542
96.571213, 16.95313
96.586539, 15.9375
96.601866, 17.10938
96.617193, 14.97396
96.632519, 15.52083
96.647846, 16.90104
96.663173, 16.09375
96.678499, 15.49479
96.693826, 15.625
96.709153, 16.38021
96.724479, 14.34896
96.739806, 15.28646
96.755133, 15.46875
96.770459, 15.18229
96.785786, 14.55729
96.801113, 15.20833
96.816439, 13.54167
96.831766, 14.86979
96.847093, 15.46875
96.862419, 15.625
96.877746, 16.74479
96.893073, 15.33854
96.908399, 13.85417
96.923726, 14.50521
96.939053, 14.32292
96.954379, 14.24479
96.969706, 14.24479
96.985033, 14.92187
97.000359, 14.14062
97.015686, 14.21875
97.031013, 14.47917
97.046339, 12.94271
97.061666, 13.95833
97.076993, 13.33333
97.092319, 13.51562
97.107646, 13.33333
97.122973, 13.85417
97.138299, 14.55729
97.153626, 15.02604
97.168953, 14.45312
97.184279, 13.80208
97.199606, 14.0625
97.214933, 14.60937
97.230259, 14.21875
97.245586, 14.08854
97.260913, 13.69792
97.276239, 14.58333
97.291566, 13.98437
97.306893, 14.81771
97.322219, 13.61979
97.337546, 14.50521
97.352873, 14.40104
97.368199, 13.72396
97.383526, 13.25521
97.398853, 13.77604
97.414179, 13.15104
97.429506, 13.93229
97.444833, 13.46354
97.460159, 14.92187
97.475486, 14.45312
97.490813, 13.90625
97.506139, 13.59375
97.521466, 13.20312
97.536793, 12.36979
97.552119, 13.25521
97.567446, 13.30729
97.582773, 14.34896
97.598099, 13.25521
97.613426, 14.55729
97.628753, 12.57812
97.644079, 13.25521
97.659406, 13.77604
97.674732, 13.85417
97.690059, 13.93229
97.705386, 13.38542
97.720712, 12.89062
97.736039, 11.875
97.751366, 13.41146
97.766692, 13.51562
97.782019, 13.07292
97.797346, 13.56771
97.812672, 12.42187
97.827999, 13.85417
97.843326, 12.68229
97.858652, 13.69792
97.873979, 14.21875
97.889306, 14.27083
97.904632, 13.69792
97.919959, 13.59375
97.935286, 13.61979
97.950612, 12.89062
97.965939, 13.48958
97.981266, 13.41146
97.996592, 13.20312
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=X-RAY DIFFRACTIONPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=1.0
##MAXX=97.996592
##MAXY=1106.38
##MINX=93.0001
##MINY=10.3125
##$CSSOLVENTNAME=
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=X-RAY DIFFRACTIONPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=1.0
##MAXX=97.996592
##MAXY=1106.38
##MINX=93.0001
##MINY=10.3125
##NPOINTS=1
##PEAKTABLE= (XY..XY)
95.176486, 1106.38
##END=


$$ === CHEMSPECTRA AUTO METADATA ===
##$CSAUTOMETADATA=
DATA CLASS=XYPOINTS
DATA TYPE=X-RAY DIFFRACTION
XUNITS=2Theta
YUNITS=Intensity
DIVERGENCE_SLIT_SIZE=18
GONIOMETER_RADIUS=280
SOLLER_SLITS=2
BETA_FILTER=N
WAVELENGTH=1.5406
WAVELENGTH_2=1.54439
WAVELENGTH_3=1.39222
WAVELENGTH_RATIO=0.5
WAVELENGTH_RANGE=1.5406
ANODE=Cu
SCAN_TYPE=COUPLED
SECONDS_PER_STEP=38.4
STEP_SIZE=0.015327
STEP_MODE=C
START_POSITION=93.0001
THETA=46.50005
2THETA=93.0001
VOLTAGE=40
CURRENT=35
##END=

##END=

`;

export default xrdJcamp1;
